module.exports = __webpack_public_path__ + "80dc3d21a50da04223228423d7abe1.png";